
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 18.421c0-.404.16-.808.479-1.117L8.05 10 .479 2.696a1.542 1.542 0 010-2.234 1.681 1.681 0 012.315 0l8.727 8.421a1.543 1.543 0 010 2.234l-8.727 8.421a1.681 1.681 0 01-2.315 0A1.546 1.546 0 010 18.421z","fill":"#585858"}})])
          )
        }
      }
    